import { ref } from 'vue';
import store from '@/store';
import { config } from '@/config.js';
import { marcarPagoEnCurso } from '@/utils/pagoEnCurso';

export { getPagoEnCursoSessionId, limpiarPagoEnCurso, CAMBIO_BUTACA_PAGO_EN_CURSO_KEY } from '@/utils/pagoEnCurso';

export function useBizumPago(deps = {}) {
    const pagarConBizumLoading = ref(false);

    const pagarConBizum = () => {
        if (!deps.sessionId) {
            const msg = 'pagarConBizum: session_id no disponible';
            if (!deps || process.env.NODE_ENV !== 'production') {
                console.warn(msg);
            }
            if (typeof deps.onError === 'function') {
                deps.onError(msg);
            }
            return;
        }

        pagarConBizumLoading.value = true;

        const params = {
            filters: {},
            session_id: deps.sessionId,
            metodo_pago: 13,
            tipo_venta: deps.tipoVenta || 'evento'
        };

        return store.dispatch(
            config.getVuexAlias('front.procesar-pago-paycomet'),
            params
        )
            .then(res => {
                const challengeUrl = res?.data?.response?.challengeUrl;
                if (challengeUrl) {
                    // El desmontaje de la SPA al navegar a la pasarela no
                    // debe liberar la reserva: el webhook la procesará con
                    // el pago completado.
                    marcarPagoEnCurso(deps.sessionId);
                    window.location.href = challengeUrl;
                    return res;
                }
                pagarConBizumLoading.value = false;
                const msg = 'No se pudo iniciar el pago con Bizum';
                if (!deps || process.env.NODE_ENV !== 'production') {
                    console.error('pagarConBizum: respuesta sin challengeUrl', res);
                }
                if (typeof deps.onError === 'function') {
                    deps.onError(msg);
                }
                return res;
            })
            .catch(err => {
                pagarConBizumLoading.value = false;
                const msg = 'Error al procesar el pago con Bizum';
                if (!deps || process.env.NODE_ENV !== 'production') {
                    console.error('pagarConBizum: error en dispatch', err);
                }
                if (typeof deps.onError === 'function') {
                    deps.onError(msg);
                }
            });
    };

    return { pagarConBizum, pagarConBizumLoading };
}
